import { t, DateTimeISO, UUID } from '../common.ts';

export const LoginRequest = t.Object(
  {
    username: t.String({ minLength: 3, maxLength: 64 }),
    // Presence, not policy — a login password is verified, never stored.
    password: t.String({ minLength: 1, maxLength: 128 }),
    turnstileToken: t.Optional(t.String()),
    mfaCode: t.Optional(t.String({ minLength: 6, maxLength: 6 })),
    deviceId: t.Optional(t.String()),
    deviceFp: t.Optional(t.String()),
  },
  { $id: 'LoginRequest' },
);

export const LoginResponse = t.Object(
  {
    accessToken: t.String(),
    refreshToken: t.String(),
    expiresIn: t.Integer(),
    user: t.Object({
      id: UUID,
      username: t.String(),
      kind: t.Union([t.Literal('admin'), t.Literal('player'), t.Literal('partner')]),
      level: t.Union([t.Integer(), t.Null()]),
      roleId: t.Union([UUID, t.Null()]),
    }),
  },
  { $id: 'LoginResponse' },
);

export const RefreshRequest = t.Object({ refreshToken: t.String() }, { $id: 'RefreshRequest' });

export const MeResponse = t.Object(
  {
    id: UUID,
    username: t.String(),
    kind: t.Union([t.Literal('admin'), t.Literal('player'), t.Literal('partner')]),
    roleId: t.Union([UUID, t.Null()]),
    level: t.Union([t.Integer(), t.Null()]),
    permissions: t.Array(t.String()),
    lastLoginAt: t.Union([DateTimeISO, t.Null()]),
  },
  { $id: 'MeResponse' },
);
